interface DeviceIntelligenceResponse {
  result: {
    session_id: string
  }
}

export const getShieldSessionId = async () => {
  try {
    const { getShield } = useShield()
    const shield = await getShield()
    const res = (await shield.getDeviceIntelligence()) as DeviceIntelligenceResponse

    return res.result.session_id
  } catch (error) {
    console.error('Error getting shield session id: ', error)
    return null
  }
}
